"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Utilitná funkcia pre porovnávanie dvoch polí. Striktná rovnosť (===). Záleží na poradí.
 * Fcia je schválne pomenovaná vágne "isEqual". V budúcnosti môže byť rozšírená o porovnávanie iných typov argumentov.
 * @param {array} - Prvý objekt
 * @param {array} - Druhý objekt
 * @returns {boolean} - True ak sa objekty rovnajú, inak false
 * @example
 * ```javascript
 * import isEqual from 'utilities/lib/isEqual';
 *
 * console.log(isEqual([], [])); // true
 * console.log(isEqual([1, 2, 3], [1, 2, 3])); // true
 * console.log(isEqual([1, 3, 2], [1, 2, 3])); // false
 * ```
 */

function isEqual(a, b) {
  if (!a || !b) {
    return false;
  }

  if (a.length !== b.length) return false;

  for (var i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

exports.default = isEqual;